var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c(_vm.coms,{tag:"component",attrs:{"cutcoms":_vm.cutcoms}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }